import { Api2_0 } from '../../../mappers/backend-types';
import * as Models from '../../../models';
import { buildParticipantStatsMapper } from '../../../mappers/api2_0/';
import { ChampionshipsEndpoints, StudentsEndpoints, AvatarsEndpoints } from '../../../endpoint';
import { ResourcesList } from '../../../models/response';

interface Filters {
  page?: number;
  pageSize?: number;
}

export interface GetChampionshipStatsProps {
  championshipId: Models.ChampionshipId;
  filters?: Filters;
}

export const calculatePosition = (index: number, currentPage: number, pageSize: number) => {
  const startPosition = (currentPage - 1) * pageSize;
  return startPosition + index + 1;
};

let avatars: Api2_0.Avatar[] | undefined;
const getAvatars: () => Promise<Api2_0.Avatar[]> = async () => {
  if (avatars) {
    return avatars;
  }
  const avatarsResponse = await AvatarsEndpoints.getAvatars();
  avatars = avatarsResponse.resources;
  return avatars;
};

export const getChampionshipStats: (
  params: GetChampionshipStatsProps,
) => Promise<ResourcesList<Models.ParticipantStats>> = async params => {
  const participantsResponse = await ChampionshipsEndpoints.getParticipants(params);
  const { resources: participants, ...restOfParticipantsResponse } = participantsResponse;

  const studentsId = participants.map(({ studentId }) => studentId);
  const studentProfilesResponse = await StudentsEndpoints.getProfile({ filters: { ids: studentsId } });
  const { resources: studentProfiles } = studentProfilesResponse;

  const avatars = await getAvatars();
  const {
    paginator: { page, limit },
  } = participantsResponse;

  const resources = participants.map((participant, index) => {
    const position = calculatePosition(index, page, limit);
    return buildParticipantStatsMapper({ studentProfiles, avatars, position })(participant);
  });

  return { resources, ...restOfParticipantsResponse };
};
